import React, { useState, useEffect, useMemo } from "react";
import { Icon, Button, Label, Pagination } from "semantic-ui-react";

// UX
import CardSettingUser from "./CardSettingUser";
import CardSettingEmployee from "./CardSettingEmployee";
import CardSettingDivision from "./CardSettingDivision";
import CardSettingUserEmployee from "./CardSettingUserEmployee";
import CardStaffSearch from "./CardStaffSearch";
import { useIntl } from "react-intl";

// Types
export type FilterType = {
  searchCode: string;
  firstName: string;
  lastName: string;
  position: string;
  organization: string | number;
};

const MASTERS = [
  ["divisionsTypeName", {}],
  // ["employmentType", {}],
  ["employmentTypeName", {}],
];

const CardStaffSetting = (props: any) => {
  const intl = useIntl();
  const [mode, setMode] = useState<"search" | "add" | "edit" | "">("");
  const [tab, setTab] = useState<string>("user-employee");

  const [filter, setFilter] = useState<Partial<FilterType>>({});

  const [selectedRow, setSelectedRow] = useState<any>(null);

  useEffect(() => {
    props.onEvent({
      message: "SearchStaff",
      params: { fetchOptionsOnly: props.fetchOptionsOnly, activePage: 1 },
    });

    if (props.controller) {
      props.controller.handleEvent({
        message: "GetMasterData",
        params: {
          masters: MASTERS,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (props.editUserProfile?.id) {
      const data = props.editUserProfile;

      const profile = {
        id: data.id,
        username: data.username,
        email: data.email,
        citizen_passport: data.citizen_passport,
        profile: {
          ...data,
          cid: data.citizen_passport || "",
        },
        employee: {},
        pre_name: data.pre_name,
        first_name: data.first_name,
        last_name: data.last_name,
        isUser: true,
      };

      handleSelected(profile, false);
    }
  }, []);

  useEffect(() => {
    setMode(props.mode || "search");
    setTab(props.tab || "");
  }, []);

  const handleChangeValue = (key: string) => (e: any, v: any) => {
    setFilter({
      ...filter,
      [key]: v.value,
    });
  };

  const handleAddStaff = () => {
    setMode("add");
    setTab("user-employee");

    props.onEvent({
      message: "SettingDivision",
      params: { action: "FETCH_DATA" },
    });

    props.setProp("profileUser", null);
    props.setProp("profileEmployee", { employment_type: "FULL_TIME", status: "ACTIVE" });
  };

  const handleSelected = (data: any, isFetchDivision: boolean) => {
    setMode("edit");
    setTab("user-employee");
    setSelectedRow(data);

    if (isFetchDivision) {
      props.onEvent({
        message: "SettingDivision",
        params: { id: data?.id, action: "FETCH_DATA" },
      });
    }

    props.onEvent({
      message: "SettingStaff",
      params: {
        action: "EDIT",
        id: data?.id,
        profile: data.profile,
        showMemberGroupPermission: props.showMemberGroupPermission,
      },
    });
  };

  const handleGoback = () => {
    setMode("search");
    setSelectedRow(null);

    if (mode === "add" && !!props.settingsUser?.id) {
      setFilter({});

      props.onEvent({ message: "SearchStaff", params: { activePage: 1 } });
    } else {
      props.onEvent({
        message: "SearchStaff",
        params: { activePage: props.staffList?.activePage, filter },
      });
    }

    props.setProp("profileUser", null);
    props.setProp("settingsUser", null);
    props.setProp("profileEmployee", null);
  };

  // #console.log("CardStaffSearch", props)

  return (
    <>
      {mode === "search" ? (
        <CardStaffSearch
          onEvent={props.onEvent}
          // data
          selectedRow={selectedRow}
          filter={filter}
          staffList={props.staffList}
          // options
          masterOptions={props.masterOptions}
          // config
          organizationFilter={props.organizationFilter}
          // callback
          onChangeValue={handleChangeValue}
          onAddStaff={handleAddStaff}
          onSelected={handleSelected}
          languageUX={props.languageUX}
        />
      ) : ["add", "edit"].includes(mode) ? (
        <div style={{ height: "100%" }}>
          <div
            style={{
              display: "flex",
              padding: "15px 0px 0 10px",
            }}
          >
            {!props.hideButtonBack && (
              <Label as="a" basic size="large" style={{ border: 0 }} onClick={handleGoback}>
                <Icon name="arrow circle left"></Icon>
                Back
              </Label>
            )}

            {/* {!props.hideTabEmployee && (
              <Button color={tab === "employee" ? "blue" : undefined} onClick={() => setTab("employee")}>
                ข้อมูลพนักงาน
              </Button>
            )} */}

            {/* {!props.hideTabUser && (
              <Button color={tab === "user" ? "blue" : undefined} onClick={() => setTab("user")}>
                ข้อมูลผู้ใช้งานระบบ
              </Button>
            )} */}

            <Button
              color={tab === "user-employee" ? "blue" : undefined}
              onClick={() => setTab("user-employee")}
            >
              ข้อมูลผู้ใช้งาน
            </Button>

            {!props.hideTabDivision && (
              <Button
                {...(tab === "division" && { color: "blue" })} // </div></div>color={tab === "division" ? "blue" : undefined}
                onClick={() => setTab("division")}
              >
                หน่วยงาน/สิทธิ
              </Button>
            )}

            <div style={{ alignSelf: "center", margin: "0px 50px" }}>
              {!!props.profileEmployee?.id && (
                <Label color="pink">
                  <Icon name="user" />{" "}
                  {/* // user บางทีก็ไม่มี pre_name
                // ไปเอา pre_name จาก profile ใน employee เพราะ employee fullname ก็ไม่ได้มีเสมอไป  */}
                  {`${
                    props.masterOptions?.prenameTh?.find(
                      (i: any) => i.value === props.profileEmployee.pre_name
                    )?.text || ""
                  } ${props.profileEmployee.first_name || ""} ${
                    props.profileEmployee.last_name || ""
                  }`}
                </Label>
              )}
            </div>
          </div>

          <hr></hr>

          {tab === "user-employee" ? (
            <CardSettingUserEmployee
              // ให้เหมือนกันทั้ง CU และ Raksthai
              // isRaksthaiRequirment={!!props.isRaksthaiRequirement}
              setProp={props.setProp}
              onEvent={props.onEvent}
              // data
              profileUser={props.profileUser}
              changePassword={props.changePassword}
              profileEmployee={props.profileEmployee}
              selectedRow={selectedRow}
              settingsUser={props.settingsUser}
              // CommonInterface
              errorMessage={props.errorMessage}
              buttonLoadCheck={props.buttonLoadCheck}
              successMessage={props.successMessage}
              // options
              masterOptions={props.masterOptions}
              roleOptions={props.roleOptions}
              masterData={props.masterData}
              memberGroupOptions={props.memberGroupOptions}
              // style
              style={props.userEmployeeStyle}
              // config
              hideDoctorForm={props.hideDoctorForm}
              showPassword2={props.showPassword2}
              pw2CheckTeacherFlag={props.pw2CheckTeacherFlag}
              hideEmployeeForm={props.hideEmployeeForm}
              showMemberGroupPermission={props.showMemberGroupPermission}
              languageUX={props.languageUX}
            />
          ) : // tab === "user-employee" ? (
          //   <CardSettingUser
          //     setProp={props.setProp}
          //     onEvent={props.onEvent}
          //     // data
          //     profileUser={props.profileUser}
          //     selectedRow={selectedRow}
          //     changePassword={props.changePassword}
          //     user={props.settingsUser}
          //     // CommonInterface
          //     successMessage={props.successMessage}
          //     errorMessage={props.errorMessage}
          //     buttonLoadCheck={props.buttonLoadCheck}
          //     // options
          //     masterOptions={props.masterOptions}
          //   />
          // ) :
          //  tab === "employee" ? (
          //   <CardSettingEmployee
          //     setProp={props.setProp}
          //     onEvent={props.onEvent}
          //     // data
          //     profileUser={props.profileUser}
          //     changePassword={props.changePassword}
          //     profileEmployee={props.profileEmployee}
          //     selectedRow={selectedRow}
          //     user={props.settingsUser}
          //     profileDivision={props.profileDivision}
          //     // CommonInterface
          //     errorMessage={props.errorMessage}
          //     buttonLoadCheck={props.buttonLoadCheck}
          //     successMessage={props.successMessage}
          //     // options
          //     masterOptions={props.masterOptions}
          //     divisionOptions={props.divisionOptions}
          //     roleOptions={props.roleOptions}
          //     // config
          //     hideDoctorForm={props.hideDoctorForm}
          //     showUserForm={props.showUserForm}
          //   />
          // ) :
          tab === "division" ? (
            <CardSettingDivision
              setProp={props.setProp}
              onEvent={props.onEvent}
              // data
              settingsUser={props.settingsUser}
              profileDivision={props.profileDivision}
              // CommonInterface
              buttonLoadCheck={props.buttonLoadCheck}
              errorMessage={props.errorMessage}
              // options
              divisionOptions={props.masterOptions.division}
              // config
              tableHeaders={props.tableHeaders}
              tableKeys={props.tableKeys}
              organizationFilter={props.organizationFilter}
              controller={props.controller}
              languageUX={props.languageUX}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

CardStaffSetting.displayName = "CardStaffSetting";

export default React.memo(CardStaffSetting);
